// Auto generated, DO NOT MODIFY
export enum WithdrawalTypeEnum {
    'US' = 'U',
    'IN' = 'I',
    'BLOCKCHAIN' = 'B'
}

type WithdrawalTypeEnumMap = Record<
    keyof typeof WithdrawalTypeEnum,
    {
        keyName: string;
        value: string;
        displayValue: string;
    }
>;

export const WithdrawalTypeEnumMap: WithdrawalTypeEnumMap = {
    'US': {
        'keyName': 'US',
        'displayValue': 'US Domestic Wire',
        'value': 'U'
    },
    'IN': {
        'keyName': 'IN',
        'displayValue': 'USD International Wire',
        'value': 'I'
    },
    'BLOCKCHAIN': {
        'keyName': 'BLOCKCHAIN',
        'displayValue': 'Blockchain Transfer',
        'value': 'B'
    }
};